import { Link  } from "react-router-dom"; 
import {FcMoneyTransfer, FcSms, FcOrgUnit,FcManager, FcMultipleSmartphones,FcUpload,FcFaq,FcSimCardChip, FcEngineering, FcCollect } from "react-icons/fc";
import { BsChatLeftDots ,BsCashStack} from "react-icons/bs";
import { FaMoneyBillTransfer , FaAward} from "react-icons/fa6";
import { IoWalletOutline } from "react-icons/io5"; 
import { RiMoneyDollarBoxLine } from "react-icons/ri";
import { SiTaxbuzz } from "react-icons/si";
import { GiPodiumWinner } from "react-icons/gi";
import { FaCashRegister } from "react-icons/fa";
import HandleCurrentPath from "./HandleCurrentPath";
import { CgUserList } from "react-icons/cg";
import { FiUsers } from "react-icons/fi";
const Menu = () =>{

  const pathname = window.location.pathname;
 
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>

        <ul>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/appUsers'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/appUsers'} >
                <FiUsers/>
                <span className="ml-4">Customers </span>
            </Link>
        </li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/dailyUsers'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/dailyUsers'} >
         <CgUserList/>
         <span className="ml-4">Customers Per Day</span>
     </Link>
</li>



<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/deposit'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/deposit'} >
         <FcMoneyTransfer/>
         <span className="ml-4">Deposits </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/winning'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/winning'} >
         <BsCashStack/>
         <span className="ml-4">Winnings </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/interactiveSms'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/interactiveSms'} >
         <FcSms/>
         <span className="ml-4">InteractiveSms </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/smsMessage'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/smsMessage'} >
         <BsChatLeftDots/>
         <span className="ml-4">Bulk Out</span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebook'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebook'} >
         <FcMultipleSmartphones/>
         <span className="ml-4">Phonebooks </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebookupload'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebookupload'} >
         <FcUpload/>
         <span className="ml-4">Upload Contacts </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/bulkbroadcast'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/bulkbroadcast'} >
         <FcFaq/>
         <span className="ml-4">Bulkbroadcast </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/senderid'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/senderid'} >
         <FcSimCardChip/>
         <span className="ml-4">Senderid </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/client'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/client'} >
         <FcManager/>
         <span className="ml-4">Client </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/payoutSetting'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/payoutSetting'} >
         < FcEngineering/>
         <span className="ml-4">Payout Setting </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/shortCodeMatches'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/shortCodeMatches'} >
         <FcCollect/>
         <span className="ml-4">ShortCode Matches </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/supportFees'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/supportFees'} >
         <SiTaxbuzz/>
         <span className="ml-4">Support Fees </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/marketingPayouts'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/marketingPayouts'} >
         <RiMoneyDollarBoxLine/>
         <span className="ml-4">Marketing Payouts </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/b2ctopup'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/b2ctopup'} >
         < FaMoneyBillTransfer/>
         <span className="ml-4">B2C Top Up </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/rewardwallet'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/rewardwallet'} >
         <IoWalletOutline/>
         <span className="ml-4">Reward Wallet </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/rewardnomination'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/rewardnomination'} >
         <FaAward/>
         <span className="ml-4">Reward Nomination </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/jackpotEntries'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/jackpotEntries'} >
         <GiPodiumWinner/>
         <span className="ml-4">Jackpot Entries </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/registerjackpot'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/registerjackpot'} >
         <FaCashRegister/>
         <span className="ml-4">Register Jackpot </span>
     </Link>
</li>
  
  </ul>
        </>
    );
}
export default Menu;